import { render, staticRenderFns } from "./context-button.vue?vue&type=template&id=678be582&fddApi"
import script from "./context-button.vue?vue&type=script&lang=js&fddApi"
export * from "./context-button.vue?vue&type=script&lang=js&fddApi"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports